import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LanguageIcon from "@material-ui/icons/Language";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import AddIcon from "@material-ui/icons/Add";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import SelectAllIcon from "@material-ui/icons/SelectAll";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ContactsIcon from "@material-ui/icons/Contacts";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import TabPanel from "../TabPanel";
import Kanban from "../../pages/Kanban";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Button, Checkbox, Chip, FormControl, IconButton, ListItemText, MenuItem, Select, Typography } from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

// TikTok mark rendered locally so the channel selector does not depend on a
// generic music-note glyph or an additional image request.
const TikTokIcon = ({ style, ...props }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...props} style={{ width: 24, height: 24, ...style }}>
    <path fill="#25F4EE" d="M15.6 3.2c.4 2.2 1.7 3.7 3.8 4.2v3.2c-1.5-.1-2.8-.6-3.8-1.4v6.1c0 3.7-2.5 5.7-5.6 5.7-2.8 0-5.1-1.9-5.1-4.8 0-3 2.4-5 5.5-5.1v3.2c-1.3 0-2.2.7-2.2 1.8 0 1 .8 1.6 1.8 1.6 1.1 0 2.2-.7 2.2-2.6V3.2h3.4Z" />
    <path fill="#FE2C55" d="M17 2c.4 2.2 1.7 3.7 3.8 4.2v2.2c-1.5-.1-2.8-.6-3.8-1.4v6.1c0 3.7-2.5 5.7-5.6 5.7-.8 0-1.5-.2-2.1-.5.3.1.7.1 1 .1 1.1 0 2.2-.7 2.2-2.6V2H17Z" />
    <path fill="#111827" d="M15.6 2v11.3c0 1.9-1.1 2.6-2.2 2.6-1 0-1.8-.6-1.8-1.6 0-1.1.9-1.8 2.2-1.8V9.3c-3.1.1-5.5 2.1-5.5 5.1 0 2.9 2.3 4.8 5.1 4.8 3.1 0 5.6-2 5.6-5.7V7.8c1 .8 2.3 1.3 3.8 1.4V7.4C20.1 6.9 18.8 5.4 18.4 3.2V2h-2.8Z" />
  </svg>
);

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    border: 0,
    borderRadius: 0,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  heading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.1, 1.5, 0.55),
  },
  headingTitle: { fontSize: "1.12rem", fontWeight: 800, letterSpacing: "-.025em" },
  tab: {
    minWidth: 0,
    flex: 1,
    padding: theme.spacing(0.25, 0.35),
    minHeight: 42,
    height: 42,
    fontSize: "0.70rem",
    lineHeight: 1,
    "& .MuiTab-wrapper": { flexDirection: "row !important", alignItems: "center", justifyContent: "center", gap: 4 },
    "& .MuiSvgIcon-root": { fontSize: "1rem", margin: "0 !important" },
  },
  headingActions: { display: "flex", alignItems: "center", gap: 4 },
  internalChatButton: {
    minWidth: 36,
    width: 36,
    height: 36,
    padding: 0,
    borderRadius: 12,
  },
  conversationMenuIcon: {
    width: 32,
    minWidth: 32,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    "& .MuiCheckbox-root": { padding: 0 },
    "& svg": { fontSize: 22 },
  },
  kanbanQuickAccess: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    minWidth: 78,
    minHeight: 34,
    height: 34,
    padding: "2px 8px",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.default,
    fontSize: "0.72rem",
    fontWeight: 700,
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
  kanbanDialogTitle: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: theme.spacing(0.75, 1.5), "& h2": { fontSize: "1rem", fontWeight: 800 } },
  kanbanDialogContent: { padding: "0 !important", overflow: "hidden", minHeight: "72vh" },
  bulkToolbar: {
    position: "absolute",
    left: 10,
    right: 10,
    bottom: 10,
    zIndex: 40,
    display: "flex",
    alignItems: "center",
    gap: 5,
    minHeight: 44,
    padding: "5px 7px",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 8px 24px rgba(25,18,55,.20)",
    "& .MuiButton-root": { minWidth: 34, padding: "5px 7px", fontSize: ".68rem", whiteSpace: "nowrap" },
  },
  bulkCount: { fontSize: ".68rem", fontWeight: 800, whiteSpace: "nowrap" },
  bulkTagSelect: { minWidth: 92, maxWidth: 120, height: 32, fontSize: ".7rem", flex: "1 1 92px" },
  statusTab: {
    minWidth: 0,
    flex: "1 1 0",
    padding: theme.spacing(0.15, 0.3),
    minHeight: 30,
    height: 30,
    fontSize: "0.68rem",
    lineHeight: 1.05,
    whiteSpace: "normal",
    "& .MuiBadge-root": { whiteSpace: "normal" },
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      fontSize: "0.64rem",
      paddingLeft: 3,
      paddingRight: 3,
    },
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "nowrap",
    background: theme.palette.background.paper,
    padding: theme.spacing(1, 1.5, 1.25),
  },
  serachInputWrapper: {
    flex: 1,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,.06)" : "#f6f5f9",
    display: "flex",
    borderRadius: 12,
    padding: "2px 8px",
    border: `1px solid ${theme.palette.divider}`,
  },
  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
    color: theme.palette.text.primary, 
    backgroundColor: theme.palette.background.default,
  },
  badge: {
    right: "-6px",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
  channelControl: {
    flex: "0 0 auto",
    minWidth: 118,
    maxWidth: 150,
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      minHeight: 22,
      paddingTop: 10,
      paddingBottom: 10,
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "none",
      flexBasis: "100%",
    },
  },
  quickActions: { display: "flex", alignItems: "center", gap: 8, padding: theme.spacing(0, 1.25, 0.7) },
  newButton: { minWidth: 44, width: 44, padding: 0, borderRadius: 12 },
  channelStrip: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 8,
    minWidth: 0,
    overflow: "visible",
    padding: theme.spacing(0, 1.25, 0.65),
  },
  channelChip: {
    flex: "0 0 auto",
    height: 36,
    borderRadius: 9,
    fontWeight: 700,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.05)" : "#fff",
    borderColor: theme.palette.divider,
  },
  channelIconChip: {
    width: 36,
    minWidth: 36,
    padding: 0,
    justifyContent: "center",
    "& .MuiChip-label": { display: "none" },
    "& .MuiChip-icon": { margin: 0, width: 22, height: 22, fontSize: 22 },
  },
  channelNumberSelect: {
    flex: "0 0 auto",
    width: 32,
    height: 30,
    "&& > div": { width: "32px !important", height: "30px !important", borderRadius: 0, background: "transparent", border: 0 },
    "&& [role='button']": {
      boxSizing: "border-box !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      minHeight: "unset !important",
      minWidth: "0 !important",
      width: "32px !important",
      height: "30px !important",
      padding: "4px 12px 4px 0 !important",
      overflow: "visible",
      backgroundColor: "transparent !important",
    },
    "&& svg[class*='MuiSelect-icon']": { right: 0, width: 10, height: 10 },
    "&& fieldset": { border: "0 !important" },
  },
  channelIcon: {
    width: 18,
    height: 22,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 18px",
    "& svg": { width: 18, height: 18, fontSize: 18 },
  },
  channelChipActive: {
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main}10`,
    borderColor: `${theme.palette.primary.main}66`,
  },
  statusTabs: {
    minHeight: 30,
    height: 30,
    margin: theme.spacing(0.2, 0.45),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.default,
    overflowX: "auto",
    scrollbarWidth: "thin",
    "& .MuiTabs-flexContainer": { width: "100%", minWidth: 0 },
    "&::-webkit-scrollbar": { height: 3 },
  },
}));

const channelIcon = (type) => {
  if (type === "whatsapp") return <WhatsAppIcon />;
  if (type === "facebook") return <FacebookIcon />;
  if (type === "instagram") return <InstagramIcon />;
  if (type === "web") return <LanguageIcon />;
  return <ChatBubbleOutlineIcon />;
};

const TicketsManager = () => {
  const classes = useStyles();
  const history = useHistory();
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("all");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [actionsAnchorEl, setActionsAnchorEl] = useState(null);
  const [kanbanOpen, setKanbanOpen] = useState(false);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedTicketIds, setSelectedTicketIds] = useState([]);
  const [visibleTicketIds, setVisibleTicketIds] = useState([]);
  const [bulkTags, setBulkTags] = useState([]);
  const [bulkTag, setBulkTag] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const { user, isAuth } = useContext(AuthContext);
  const [openCount, setOpenCount] = useState(0);
  const [unansweredCount, setUnansweredCount] = useState(0);
  const searchTimeoutRef = useRef();
  const userQueueIds = (user?.queues || []).map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [channels, setChannels] = useState([]);
  const [selectedInboxIds, setSelectedInboxIds] = useState(() => {
    try {
      const saved = window.localStorage.getItem("crm-selected-inbox-ids");
      const parsed = saved === null ? [] : JSON.parse(saved);
      return Array.isArray(parsed) ? parsed.map(Number).filter(Number.isFinite) : [];
    } catch (_error) {
      return [];
    }
  });
  const [channelsReady, setChannelsReady] = useState(false);

  useEffect(() => {
    if (!isAuth) return;
    api.get("/crm/channels")
      .then(({ data }) => {
        const items = Array.isArray(data.channels) ? data.channels : [];
        setChannels(items);
        const savedSelection = window.localStorage.getItem("crm-selected-inbox-ids");
        if (savedSelection === null) {
          const currentWhatsapp = items.find((channel) => channel.type === "whatsapp" && channel.instanceName === "crm-pruebas")
            || items.find((channel) => channel.type === "whatsapp" && /pruebas/i.test(channel.name || ""));
          if (currentWhatsapp) {
            const defaultSelection = [Number(currentWhatsapp.id)];
            setSelectedInboxIds(defaultSelection);
            window.localStorage.setItem("crm-selected-inbox-ids", JSON.stringify(defaultSelection));
          }
        }
      })
      .catch(toastError)
      .finally(() => setChannelsReady(true));
  }, [isAuth]);

  useEffect(() => {
    if (tab === "search") {
      setSearchParam("");
    }
  }, [tab]);

  useEffect(() => () => clearTimeout(searchTimeoutRef.current), []);

  useEffect(() => {
    if (!selectionMode) return;
    api.get("/crm/tags/").then(({ data }) => setBulkTags(data.tags || [])).catch(toastError);
  }, [selectionMode]);

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeoutRef.current);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setTab("open");
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 180);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const handleChannelChange = (event) => {
    const values = event.target.value || [];
    if (values.includes("all")) {
      setSelectedInboxIds([]);
      window.localStorage.setItem("crm-selected-inbox-ids", "[]");
      return;
    }

    setTab("search");
    const selection = [...new Set(values.map(Number).filter(Number.isFinite))];
    setSelectedInboxIds(selection);
    window.localStorage.setItem("crm-selected-inbox-ids", JSON.stringify(selection));
  };

  const channelSelectionLabel = () => {
    if (!selectedInboxIds.length) return "Todos los canales";
    return channels
      .filter((channel) => selectedInboxIds.includes(Number(channel.id)))
      .map((channel) => channel.name)
      .join(", ") || "Canales seleccionados";
  };

  const channelTypes = [
    { type: "whatsapp", label: "WhatsApp", icon: <WhatsAppIcon style={{ color: "#16a34a" }} /> },
    { type: "facebook", label: "Facebook", icon: <FacebookIcon style={{ color: "#1877f2" }} /> },
    { type: "instagram", label: "Instagram", icon: <InstagramIcon style={{ color: "#c13584" }} /> },
    { type: "web", label: "Web", icon: <LanguageIcon style={{ color: "#0284c7" }} /> },
    { type: "tiktok", label: "TikTok", icon: <TikTokIcon style={{ color: "#111827" }} /> },
  ];

  const openOfficialConnectionSetup = (type) => {
    if (type === "facebook" || type === "instagram") {
      history.push("/meta");
      return;
    }
    if (type === "web") {
      history.push("/Settings");
      return;
    }
    toast.info("TikTok requiere una app oficial de TikTok Business y sus credenciales de API.");
  };

  const selectChannelType = (type) => {
    const ids = channels.filter((channel) => channel.type === type).map((channel) => Number(channel.id));
    if (!ids.length) return;
    const allSelected = ids.every((id) => selectedInboxIds.includes(id));
    const next = allSelected
      ? selectedInboxIds.filter((id) => !ids.includes(id))
      : [...new Set([...selectedInboxIds, ...ids])];
    setSelectedInboxIds(next);
    window.localStorage.setItem("crm-selected-inbox-ids", JSON.stringify(next));
  };

  const selectWhatsappNumbers = (event) => {
    const whatsappIds = channels.filter((channel) => channel.type === "whatsapp").map((channel) => Number(channel.id));
    const selected = (event.target.value || []).map(Number).filter(Number.isFinite);
    const next = [...new Set([...selectedInboxIds.filter((id) => !whatsappIds.includes(id)), ...selected])];
    setSelectedInboxIds(next);
    window.localStorage.setItem("crm-selected-inbox-ids", JSON.stringify(next));
  };

  const selectChannelNumbers = (type, event) => {
    const channelIds = channels.filter((channel) => channel.type === type).map((channel) => Number(channel.id));
    const selected = (event.target.value || []).map(Number).filter(Number.isFinite);
    const next = [...new Set([...selectedInboxIds.filter((id) => !channelIds.includes(id)), ...selected])];
    setSelectedInboxIds(next);
    window.localStorage.setItem("crm-selected-inbox-ids", JSON.stringify(next));
  };

  const toggleTicketSelection = (ticketId) => {
    setSelectedTicketIds((current) => current.includes(ticketId) ? current.filter((id) => id !== ticketId) : [...current, ticketId]);
  };

  const allVisibleSelected = visibleTicketIds.length > 0 && visibleTicketIds.every(id => selectedTicketIds.includes(id));
  const toggleSelectAllVisible = () => {
    setSelectedTicketIds(current => allVisibleSelected
      ? current.filter(id => !visibleTicketIds.includes(id))
      : [...new Set([...current, ...visibleTicketIds])]);
  };

  const runBulkAction = async (action) => {
    if (!selectedTicketIds.length || bulkLoading) return;
    if (action === "label" && !bulkTag) {
      toast.info("Seleccioná una etiqueta.");
      return;
    }
    setBulkLoading(true);
    try {
      await api.post("/crm/tickets/bulk", { ticketIds: selectedTicketIds, action, ...(action === "label" ? { label: bulkTag } : {}) });
      toast.success(`${selectedTicketIds.length} chat${selectedTicketIds.length === 1 ? "" : "s"} actualizado${selectedTicketIds.length === 1 ? "" : "s"}.`);
      setSelectedTicketIds([]);
    } catch (error) {
      toastError(error);
    } finally {
      setBulkLoading(false);
    }
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      {selectionMode && (
        <Paper elevation={8} className={classes.bulkToolbar} aria-label="Acciones para chats seleccionados">
          <Typography className={classes.bulkCount}>{selectedTicketIds.length} seleccionados</Typography>
          <Button size="small" onClick={toggleSelectAllVisible} startIcon={<SelectAllIcon fontSize="small" />} aria-label="Seleccionar todos los chats visibles">{allVisibleSelected ? "Ninguno" : "Todos"}</Button>
          <Select displayEmpty value={bulkTag} onChange={event => setBulkTag(event.target.value)} className={classes.bulkTagSelect} aria-label="Etiqueta para los chats seleccionados">
            <MenuItem value="" disabled>Etiqueta</MenuItem>
            {bulkTags.map(tag => <MenuItem key={tag.id || tag.name} value={tag.name}>{tag.name}</MenuItem>)}
          </Select>
          <IconButton size="small" disabled={!selectedTicketIds.length || bulkLoading} onClick={() => runBulkAction("label")} title="Aplicar etiqueta" aria-label="Aplicar etiqueta"><LabelOutlinedIcon fontSize="small" /></IconButton>
          <IconButton size="small" disabled={!selectedTicketIds.length || bulkLoading} onClick={() => runBulkAction("pending")} title="Mover a pendientes" aria-label="Mover chats a pendientes"><HourglassEmptyIcon fontSize="small" /></IconButton>
          <IconButton size="small" disabled={!selectedTicketIds.length || bulkLoading} onClick={() => runBulkAction("resolve")} title="Marcar como resueltos" aria-label="Marcar chats como resueltos"><DoneAllIcon fontSize="small" /></IconButton>
          <IconButton size="small" onClick={() => { setSelectionMode(false); setSelectedTicketIds([]); }} title="Cerrar selección" aria-label="Cerrar selección"><CloseIcon fontSize="small" /></IconButton>
        </Paper>
      )}
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(e) => setNewTicketModalOpen(false)}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        <div className={classes.heading}>
          <Typography className={classes.headingTitle}>Conversaciones</Typography>
          <div className={classes.headingActions}>
            <Button
              className={classes.internalChatButton}
              variant="outlined"
              onClick={(event) => setActionsAnchorEl(event.currentTarget)}
              title="Más opciones"
              aria-label="Más opciones de conversaciones"
              aria-controls={actionsAnchorEl ? "conversation-actions-menu" : undefined}
              aria-haspopup="true"
            >
              <MoreVertIcon />
            </Button>
            <Menu
              id="conversation-actions-menu"
              anchorEl={actionsAnchorEl}
              open={Boolean(actionsAnchorEl)}
              onClose={() => setActionsAnchorEl(null)}
              keepMounted
            >
              <MenuItem onClick={() => { setActionsAnchorEl(null); history.push("/internal-chat"); }}>
                <span className={classes.conversationMenuIcon}><ChatBubbleOutlineIcon /></span><span>Chat interno</span>
              </MenuItem>
              <MenuItem onClick={() => { setActionsAnchorEl(null); history.push("/quickAnswers"); }}>
                <span className={classes.conversationMenuIcon}><FlashOnIcon /></span><span>Respuestas rápidas</span>
              </MenuItem>
              <MenuItem onClick={() => { setActionsAnchorEl(null); history.push("/tags"); }}>
                <span className={classes.conversationMenuIcon}><LabelOutlinedIcon /></span><span>Etiquetas</span>
              </MenuItem>
              <MenuItem onClick={() => { setActionsAnchorEl(null); history.push("/scheduled-messages"); }}>
                <span className={classes.conversationMenuIcon}><ScheduleIcon /></span><span>Mensajes programados</span>
              </MenuItem>
              <MenuItem onClick={() => { setActionsAnchorEl(null); history.push("/contacts"); }}>
                <span className={classes.conversationMenuIcon}><ContactsIcon /></span><span>Contactos</span>
              </MenuItem>
              <MenuItem onClick={() => { setActionsAnchorEl(null); setSelectionMode((mode) => !mode); setSelectedTicketIds([]); }}>
                <span className={classes.conversationMenuIcon}><Checkbox size="small" checked={selectionMode} tabIndex={-1} /></span><span>{selectionMode ? "Salir de selección" : "Seleccionar chats"}</span>
              </MenuItem>
            </Menu>
            <Button className={classes.newButton} variant="contained" color="primary" onClick={() => setNewTicketModalOpen(true)} aria-label="Nueva conversación"><AddIcon /></Button>
            <div
              className={classes.kanbanQuickAccess}
              title="Opciones de Kanban"
              onClick={() => setKanbanOpen(true)}
              role="button"
              aria-label="Abrir Kanban"
            >
              <ViewColumnIcon fontSize="small" />
              <span>Kanban</span>
            </div>
            <Dialog open={kanbanOpen} onClose={() => setKanbanOpen(false)} fullWidth maxWidth="xl" PaperProps={{ style: { height: "86vh", maxHeight: "860px", margin: 12 } }}>
              <DialogTitle disableTypography className={classes.kanbanDialogTitle}>
                <Typography>Kanban</Typography>
                <IconButton size="small" onClick={() => setKanbanOpen(false)} aria-label="Cerrar Kanban"><CloseIcon /></IconButton>
              </DialogTitle>
              <DialogContent className={classes.kanbanDialogContent}><Kanban /></DialogContent>
            </Dialog>
          </div>
        </div>
        <div className={classes.channelStrip}>
          <FormControl variant="outlined" size="small" className={classes.channelNumberSelect} title="Todos los canales">
            <Select
              displayEmpty
              multiple
              value={!selectedInboxIds.length ? ["all"] : []}
              onChange={handleChannelChange}
              renderValue={() => <span className={classes.channelIcon}><AllInboxIcon /></span>}
              inputProps={{ "aria-label": "Seleccionar todos los canales" }}
            >
              <MenuItem value="all"><ListItemText primary="Todos los canales" /><Checkbox color="primary" checked={!selectedInboxIds.length} /></MenuItem>
            </Select>
          </FormControl>
          {channelTypes.map((item) => {
            const itemChannels = channels.filter((channel) => channel.type === item.type);
            const ids = itemChannels.map((channel) => Number(channel.id));
            const selected = selectedInboxIds.filter((id) => ids.includes(id));
            return (
              <FormControl key={item.type} variant="outlined" size="small" className={classes.channelNumberSelect} title={`Seleccionar ${item.label}`}>
                <Select
                  displayEmpty
                  multiple
                  value={selected}
                  onChange={(event) => selectChannelNumbers(item.type, event)}
                  renderValue={() => <span className={classes.channelIcon}>{item.icon}</span>}
                  inputProps={{ "aria-label": `Seleccionar cuentas de ${item.label}` }}
                >
                  {itemChannels.length ? itemChannels.map((channel) => (
                    <MenuItem key={channel.id} value={Number(channel.id)}>
                      <ListItemText primary={channel.name || item.label} secondary={channel.label || channel.instanceName} />
                      <Checkbox color="primary" checked={selected.includes(Number(channel.id))} />
                    </MenuItem>
                  )) : (item.type === "facebook" || item.type === "instagram" || item.type === "web" || item.type === "tiktok") ? (
                    <MenuItem onClick={() => openOfficialConnectionSetup(item.type)}>
                      <ListItemText
                        primary={`Vincular ${item.label}`}
                        secondary={item.type === "tiktok" ? "Requiere TikTok Business API" : item.type === "web" ? "Abrir configuración del canal" : "Abrir integración oficial de Meta"}
                      />
                    </MenuItem>
                  ) : <MenuItem disabled>Sin conexiones</MenuItem>}
                </Select>
              </FormControl>
            );
          })}
        </div>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<CheckBoxIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"search"}
            icon={<SearchIcon />}
            label={i18n.t("tickets.tabs.search.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className={classes.statusTabs}
        >
          <Tab
            label={
              <Badge className={classes.badge} badgeContent={openCount} color="primary">
                Todos
              </Badge>
            }
            value={"all"}
            className={classes.statusTab}
          />
          <Tab
            label={
              "M\u00edas"
            }
            value={"open"}
            className={classes.statusTab}
          />
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={unansweredCount}
                color="secondary"
              >
                No contestadas
              </Badge>
            }
            value={"unanswered"}
            className={classes.statusTab}
          />
        </Tabs>
        <Paper className={classes.ticketsWrapper}>
          {channelsReady && tabOpen === "all" && <TicketsList status="open" showAll selectedQueueIds={selectedQueueIds} selectedInboxIds={selectedInboxIds} updateCount={setOpenCount} selectionMode={selectionMode} selectedTicketIds={selectedTicketIds} onToggleTicket={toggleTicketSelection} onVisibleTicketsChange={setVisibleTicketIds} />}
          {channelsReady && tabOpen === "open" && <TicketsList status="open" showAll={false} selectedQueueIds={selectedQueueIds} selectedInboxIds={selectedInboxIds} selectionMode={selectionMode} selectedTicketIds={selectedTicketIds} onToggleTicket={toggleTicketSelection} onVisibleTicketsChange={setVisibleTicketIds} />}
          {channelsReady && tabOpen === "unanswered" && <TicketsList status="open" showAll onlyUnanswered selectedQueueIds={selectedQueueIds} selectedInboxIds={selectedInboxIds} updateCount={setUnansweredCount} selectionMode={selectionMode} selectedTicketIds={selectedTicketIds} onToggleTicket={toggleTicketSelection} onVisibleTicketsChange={setVisibleTicketIds} />}
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        {channelsReady && <TicketsList
          status="closed"
          showAll={true}
          selectedQueueIds={selectedQueueIds}
          selectedInboxIds={selectedInboxIds}
          selectionMode={selectionMode}
          selectedTicketIds={selectedTicketIds}
          onToggleTicket={toggleTicketSelection}
          onVisibleTicketsChange={setVisibleTicketIds}
        />}
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {channelsReady && <TicketsList
          searchParam={searchParam}
          showAll={true}
          selectedQueueIds={selectedQueueIds}
          selectedInboxIds={selectedInboxIds}
          selectionMode={selectionMode}
          selectedTicketIds={selectedTicketIds}
          onToggleTicket={toggleTicketSelection}
          onVisibleTicketsChange={setVisibleTicketIds}
        />}
      </TabPanel>
    </Paper>
  );
};

export default TicketsManager;
